export default __webpack_public_path__ + "static/media/deal.5c0747df.svg";